var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.47833C11.4717 6.15833 12.7625 5 13.8733 5C15.54 5 16.5925 6.84417 17.2067 9.3475C17.7933 11.7383 17.6233 15 15.54 15C14.6117 15 13.3333 13.6958 12.0833 11.9567C11.2879 10.8607 10.5908 9.69679 10 8.47833Z",
    stroke: "#464D6D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 8.47833C8.52833 6.15833 7.23749 5 6.12666 5C4.45999 5 3.40749 6.84417 2.79333 9.3475C2.20666 11.7383 2.37666 15 4.45999 15C5.38833 15 6.66666 13.6958 7.91666 11.9567C8.74999 10.7975 9.44416 9.6375 9.99999 8.47833Z",
    stroke: "#464D6D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.8244ebc2.svg";
export { ForwardRef as ReactComponent };